/* Draft UX layer. Reuses existing forms and EasySearch Clear filters; no storage purge or cart writes. */
(function () {
 'use strict';
 if (window.__rrShoppingV2) { window.__rrShoppingV2.scan(); return; }
 const targetLinks = new WeakMap(), vehicles = new Map();
 let cfg = {}, navigating = false;
 const config = () => { try { return JSON.parse(document.querySelector('[data-rrx-config]')?.textContent || '{}'); } catch (_) { return {}; } };
 const enabled = key => cfg[key] === true;
 function localUrl(path) {
  const url = new URL(path, location.origin);
  for (const key of ['preview_theme_id','_fd','pb']) {
   const value = new URL(location.href).searchParams.get(key);
   if (value !== null) url.searchParams.set(key, value);
  }
  return url;
 }
 function cardUrl(link) {
  try {
   const url = new URL(targetLinks.get(link) || link.getAttribute('href'), location.href);
   if (url.origin !== location.origin || !/\/collections\/[^/]+\/[a-z0-9-]+-esi\d+\/?$/i.test(url.pathname)) return null;
   for (const key of [...url.searchParams.keys()]) if (['rr_category','rr_brand','sort_by','page'].includes(key) || key.startsWith('filter.')) url.searchParams.delete(key);
   return localUrl(url.href);
  } catch (_) { return null; }
 }
 function clearControl() {
  const finder = document.querySelector('.rrf-fitment .easysearch-container');
  if (!finder) return null;
  const known = finder.querySelector('.rrfa-clear,.rrf-clear-control');
  if (known) return {finder,button:known};
  const nodes = [...finder.querySelectorAll('button,a,[role="button"],input[type="reset"],div,span')];
  const matches = nodes.filter(node => !node.querySelector('select') && /^(clear filters|clear|reset selections|reset filters)$/i.test(String(node.value || node.textContent).trim().replace(/\s+/g,' ')));
  const button = matches.find(node => node.matches('button,a,[role="button"],input')) || matches.find(node => /easysearch.*(?:btn|button)/i.test(node.className)) || null;
  return button ? {finder,button} : null;
 }
 function cleared(finder) { return [...finder.querySelectorAll('select')].every(select => select.selectedIndex <= 0 || !select.value); }
 function resetViaApp(control) {
  // Prevent only a clear link's default navigation. Keep the app's own click handlers.
  const preventNavigation = event => event.preventDefault();
  control.button.addEventListener('click',preventNavigation,{once:true,capture:true});
  control.button.click();
 }
 function cardMessage(link) {
  let message = document.querySelector('[data-rrx-card-message]');
  if (!message) { message=document.createElement('p');message.className='rrx-card-message';message.dataset.rrxCardMessage='';message.setAttribute('role','status');document.querySelector('#rr-popular-vehicles .rrv__heading')?.after(message); }
  message.textContent='The vehicle finder is still resetting. Please clear its filters, then choose your vehicle again.';
  link.focus();
 }
 async function activateCard(event) {
  if (!enabled('card_priority')) return;
  const link=event.target instanceof Element ? event.target.closest('a[data-rr-generation-link]') : null;
  if (!link || event.defaultPrevented) return;
  const destination=cardUrl(link); if(!destination) return;
  const control=clearControl();
  link.href=destination.href;
  if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button===1||link.target==='_blank') {
   if(control) { try { resetViaApp(control); } catch(_) {} }
   return; // Preserve modified-click/new-tab browser behaviour.
  }
  if(event.type!=='click'||event.button!==0) return;
  event.preventDefault();event.stopImmediatePropagation();
  if(navigating)return;
  navigating=true;link.setAttribute('aria-busy','true');
  try {
   document.querySelector('[data-rrx-card-message]')?.remove();
   if(control) {
    resetViaApp(control);
    const start=performance.now();let resetSince=null;
    await new Promise(resolve=>{
     const check=()=>{const now=performance.now();if(cleared(control.finder)){if(resetSince===null)resetSince=now;}else resetSince=null;if((resetSince!==null&&now-resetSince>=150)||now-start>1000)resolve();else setTimeout(check,25);};
     setTimeout(check,25);
    });
    if(!cleared(control.finder)){cardMessage(link);return;}
   }
   // One explicit vehicle URL, never a compound of an old vehicle and the clicked vehicle.
   location.assign(destination.href);
  } catch (_) { cardMessage(link); }
  finally { navigating=false;link.removeAttribute('aria-busy'); }
 }
 window.addEventListener('click',activateCard,true);
 window.addEventListener('auxclick',activateCard,true);
 function elem(tag,className,text) {const e=document.createElement(tag);if(className)e.className=className;if(text!==undefined)e.textContent=text;return e;}
 function link(path,text,className) {const a=elem('a',className,text);a.href=localUrl(path).href;return a;}
 function currentVehicle(root) {return root.querySelector('[data-rr-selected-vehicle]')?.textContent.trim()||root.dataset.fitmentTag?.split('-esi')[0].replaceAll('-',' ')||'Your vehicle';}
 function enhance(root) {
  if(vehicles.has(root)||!root.querySelector('[data-rr-title]'))return;
  const state={frame:0,categorySignature:'',activeSignature:'',selectorBound:false};vehicles.set(root,state);
  const header=root.querySelector('.rr-vehicle__header');if(!header)return;
  const breadcrumb=elem('nav','rrx-breadcrumb width--content');breadcrumb.setAttribute('aria-label','Breadcrumb');
  breadcrumb.append(link(cfg.root||'/','Home'),elem('span','','/'),link((cfg.root||'/')+'#rr-popular-vehicles','Shop by vehicle'),elem('span','','/'));
  const current=elem('span');current.setAttribute('aria-current','page');breadcrumb.append(current);header.before(breadcrumb);
  const eyebrow=elem('span','rrx-eyebrow','Your selected vehicle');header.firstElementChild.prepend(eyebrow);
  const categories=elem('nav','rrx-category-nav width--content');categories.setAttribute('aria-label','Shop categories for this vehicle');categories.hidden=true;header.after(categories);
  const active=elem('div','rrx-active-filters width--content');active.hidden=true;categories.after(active);
  const help=elem('div','rrx-help width--content');
  const helpText=elem('div');helpText.append(elem('strong','','Building something specific? '),document.createTextNode('Tell us about your car and the parts you have in mind.'));
  help.append(helpText,link((cfg.root||'/')+'pages/contact','Ask our team  \u2192'));root.append(help);
  function submit(category,brand) {
   if(!root.index||!root.form)return;
   if(category!==undefined)root.category.value=category;
   if(brand!==undefined)root.brand.value=brand;
   root.form.requestSubmit();
  }
  categories.addEventListener('click',event=>{
   const a=event.target.closest('a[data-rrx-category]');if(!a||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0||!enabled('vehicle_ui')||!root.index)return;
   event.preventDefault();submit(a.dataset.rrxCategory,'');
  });
  active.addEventListener('click',event=>{
   const b=event.target.closest('button[data-rrx-remove]');if(!b||!enabled('vehicle_ui'))return;
   if(b.dataset.rrxRemove==='category')submit('',undefined);else submit(undefined,'');
  });
  function sync() {
   if(!root.isConnected)return;
   const on=enabled('vehicle_ui');root.classList.toggle('rrx-ready',on);
   breadcrumb.hidden=!on;eyebrow.hidden=!on;help.hidden=!on;
   if(!on){categories.hidden=true;active.hidden=true;root.vehicleSection?.removeAttribute('data-rrx-finder-hidden');root.emptyCollectionHeader?.removeAttribute('data-rrx-finder-hidden');root.removeAttribute('data-rrx-selector-ready');if(!root.hasAttribute('data-rr-mobile')&&root.vehicleWidget&&root.vehiclePlaceholder?.parentNode){root.vehicleDialog?.close();root.vehiclePlaceholder.after(root.vehicleWidget);}return;}
   const vehicle=currentVehicle(root);if(current.textContent!==vehicle)current.textContent=vehicle;
   if(root.emptyCollectionHeader&&!root.emptyCollectionHeader.hasAttribute('data-rrx-finder-hidden'))root.emptyCollectionHeader.setAttribute('data-rrx-finder-hidden','');
   // The existing component owns the dialog, form listeners, focus and selected values.
   if(root.vehicleWidget&&root.vehicleOpen&&root.vehicleDialog) {
    if(!state.selectorBound){
     root.vehicleOpen.addEventListener('click',()=>{if(enabled('vehicle_ui'))root.querySelector('[data-rr-vehicle-body]').append(root.vehicleWidget);},true);
     root.vehicleDialog.addEventListener('close',()=>{if(enabled('vehicle_ui')&&!root.hasAttribute('data-rr-mobile'))root.vehicleOpen.focus();});
     state.selectorBound=true;
    }
    root.setAttribute('data-rrx-selector-ready','');
    if(root.canCollapseVehicleSection&&root.vehicleSection&&!root.vehicleSection.hasAttribute('data-rrx-finder-hidden'))root.vehicleSection.setAttribute('data-rrx-finder-hidden','');
   }
   if(!Array.isArray(root.index)||!root.config?.categories)return;
   const counts=new Map();for(const item of root.index)counts.set(item.category,(counts.get(item.category)||0)+1);
   const order=['exhaust','suspension','wheels','intake','brakes','exterior'].filter(key=>counts.has(key));
   const selected=root.selection||{category:'',brand:''};
   const sig=JSON.stringify([order,selected.category,root.dataset.fitmentTag]);
   if(sig!==state.categorySignature){
    state.categorySignature=sig;categories.replaceChildren();
    for(const key of ['',...order]){
     const url=root.baseUrl();if(key)url.searchParams.set('rr_category',key);
     const a=elem('a','rrx-category-chip');a.href=url.href;a.dataset.rrxCategory=key;
     a.append(elem('span','',key?root.config.categories[key]:'All parts'));
     const arrow=elem('span','','\u2192');arrow.setAttribute('aria-hidden','true');a.append(arrow);
     if(selected.category===key)a.setAttribute('aria-current','true');categories.append(a);
    }
   }
   categories.hidden=false;
   const activeSig=JSON.stringify([selected.category,selected.brand]);
   if(activeSig!==state.activeSignature){
    state.activeSignature=activeSig;active.replaceChildren();
    if(selected.category||selected.brand)active.append(elem('span','','Filtered by'));
    for(const key of ['category','brand'])if(selected[key]){
     const label=key==='category'?(root.config.categories[selected[key]]||selected[key]):selected[key];
     const b=elem('button','',label+'  \u00d7');b.type='button';b.dataset.rrxRemove=key;b.setAttribute('aria-label','Remove '+label+' filter');active.append(b);
    }
   }
   active.hidden=!selected.category&&!selected.brand;
  }
  state.sync=sync;
  const schedule=()=>{cancelAnimationFrame(state.frame);state.frame=requestAnimationFrame(sync);};
  state.observer=new MutationObserver(schedule);
  state.observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['data-index-state','data-rr-vehicle-ready','data-rr-mobile','data-total']});
  root.addEventListener('change',schedule);root.addEventListener('submit',schedule);
  sync();
 }
 function labelMobileButtons(scope){
  if(!enabled('button_style')||!scope.querySelectorAll)return;
  const list=[...(scope.matches?.('button.quick-add-button-mobile')?[scope]:[]),...scope.querySelectorAll('button.quick-add-button-mobile')];
  for(const b of list)if(!b.hasAttribute('aria-label')&&!b.textContent.trim())b.setAttribute('aria-label','Add to cart');
 }
 function scan(){
  cfg=config();
  document.documentElement.classList.toggle('rrx-buy-ui',enabled('button_style'));
  document.documentElement.classList.toggle('rrx-vehicle-ui',enabled('vehicle_ui'));
  document.querySelectorAll('a[data-rr-generation-link]').forEach(a=>{if(!targetLinks.has(a))targetLinks.set(a,a.getAttribute('href'));});
  labelMobileButtons(document);
  vehicles.forEach((state,root)=>{if(!root.isConnected){state.observer?.disconnect();cancelAnimationFrame(state.frame);vehicles.delete(root);}else state.sync?.();});
  if(enabled('vehicle_ui'))document.querySelectorAll('rr-vehicle-results').forEach(enhance);
 }
 window.__rrShoppingV2={scan};
 const buttonObserver=new MutationObserver(changes=>{for(const change of changes)for(const node of change.addedNodes)if(node.nodeType===1)labelMobileButtons(node);});
 buttonObserver.observe(document.documentElement,{childList:true,subtree:true});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
 document.addEventListener('shopify:section:load',scan);
 document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(scan));
 window.addEventListener('pageshow',()=>{navigating=false;scan();});
 window.addEventListener('resize',()=>{for(const state of vehicles.values()){cancelAnimationFrame(state.frame);state.frame=requestAnimationFrame(state.sync);}}, {passive:true});
 window.addEventListener('popstate',()=>requestAnimationFrame(scan));
 customElements.whenDefined('rr-vehicle-results').then(()=>requestAnimationFrame(scan));
})();
